import { debug } from '../../utils/DebugUtil';
export const unregisterServiceWorker = scriptUrl => {
  if ('serviceWorker' in navigator) {
    return navigator.serviceWorker.getRegistration(scriptUrl).then(oldRegistration => {
      if (oldRegistration) {
        debug('start to unregister unwanted service worker: ', scriptUrl);
        return oldRegistration.unregister().then(() => {
          debug('unregistered', scriptUrl);
        }).catch(() => {
          debug('failed to unregister', scriptUrl);
        });
      } else {
        debug('no unwanted service worker to unregister');
      }
      return undefined;
    }).catch(() => {
      debug('failed to get registration', scriptUrl);
    });
  }
  return Promise.resolve();
};